import type { EmojiEntry, EmojiEntrySkin } from "./data";
import { serverApiUrl } from "ls/api/urls";
import { isNumber } from "@/common/general";
import { setBuffer } from "../interop/bufferManager";

function getPreferredSkinTone() {
  try {
    const value = localStorage.getItem("emoji-skin-tone");
    if (value) {
      const parsed: unknown = JSON.parse(value);
      if (isNumber(parsed)) {
        return parsed;
      }
    }
  } catch {
    // ignore
  }
  return undefined;
}

export function setPreferredSkinTone(skinTone: number): void {
  try {
    const value = JSON.stringify(skinTone);
    localStorage.setItem("emoji-skin-tone", value);
  } catch {
    // ignore
  }
}

export const defaultSkinTone = 0;
export const preferredSkinTone = getPreferredSkinTone() ?? defaultSkinTone;

export function getPreferredSkinToneEmojiVariant(emoji: EmojiEntry): EmojiEntrySkin {
  const skinVariants = emoji.skins;
  const preferred = skinVariants[preferredSkinTone];
  if (preferred) return preferred;

  const fallback = skinVariants[defaultSkinTone];
  if (!fallback) {
    throw new Error(`Failed to find default skin tone for emoji ${emoji.id}`);
  }

  return fallback;
}

export function getUrlFromUnified(unified: string) {
  return new URL(`emoji/${unified}.png`, serverApiUrl);
}

export async function getEmojiImageIntoBuffer(unified: string) {
  const emojiUrl = getUrlFromUnified(unified);
  const response = await fetch(emojiUrl, { mode: "cors" });
  if (!response.ok) throw new Error(`Failed to fetch emoji ${unified}`);

  const buffer = await response.arrayBuffer();
  const bufferId = setBuffer(buffer);
  return bufferId;
}

export function getUrlFromSkin(emoji: EmojiEntrySkin) {
  return getUrlFromUnified(emoji.unified).toString();
}
